import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'

function NativeApprovalDisplayComponent(_props: WorkflowToolComponentProps) {
  return null
}

function downloadApproval(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function nativeApprovalToMarkdown(_nodeExecution: NodeExecution): string {
  return ''
}

export const NativeApprovalDisplay = createWorkflowToolComponent(
  NativeApprovalDisplayComponent,
  downloadApproval,
  nativeApprovalToMarkdown
)
